import React, { useEffect, useState } from "react";
import { Col, Row, Form, Input, Card, message, notification, Modal } from "antd";
import { Select } from "antd";
import { useNavigate } from "react-router-dom";
import { BiCheck } from "react-icons/bi";
import logo from "../../../assets/frontendassets/logo.jpg";

import { checkUsernameAvailability, createRazorpayOrder, getallproduct, getallproducts, getCustomerByID, getHomePageProducts, payonline, storeOrder, storeTripodSevenpodOrder, verifyPayment } from "../../../utils/API";
import ThankYou from "../Cart/ThankYou";

const { Option } = Select;

const TripodPayonlineUser: React.FC = () => {
  const [productData, setProductData] = React.useState<any>([]);
  const [form] = Form.useForm();
  const [sponsorId, setSponsorId] = React.useState<string | null>(null);
  const [isLoginModalVisible, setIsLoginModalVisible] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [transactionId, setTransactionId] = useState<string>("");
  const [address, setAddress] = useState("");
  const [pincode, setPincode] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isTripod, setIsTripod] = useState(true);
  const [isSevenpod, setIsSevenpod] = useState(false);
  const [username, setUsername] = useState('');
  const [isUsernameAvailable, setIsUsernameAvailable] = useState<boolean | null>(null);
  const navigate = useNavigate();
  const [selectedProducts, setSelectedProducts] = useState<{
    product1: string | null;
    product2: string | null;
    product3: string | null;
    product4: string | null;
    product5: string | null;
    product6: string | null;
    product7: string | null;
  }>({
    product1: null,
    product2: null,
    product3: null,
    product4: null,
    product5: null,
    product6: null,
    product7: null,
  });



  useEffect(() => {
    const storedAddress = localStorage.getItem("address");
    const storedPincode = localStorage.getItem("pincode");

    if (storedAddress) setAddress(storedAddress);
    if (storedPincode) setPincode(storedPincode);
  }, []);

  useEffect(() => {

    getHomePageProducts()
      .then((response) => {
        setProductData(response.products.filter((product: any) => product.isUpcoming === false));
      })
      .catch((error) => {
        message.error("Network error. Please try again.");
      });


  }, [form]);

  useEffect(() => {
    if (username) {
      const checkAvailability = async () => {
        try {
          const available = await checkUsernameAvailability(username);
          setIsUsernameAvailable(available);
        } catch (error) {
          console.error('Error checking username availability:', error);
        }
      };

      const delayDebounceFn = setTimeout(() => {
        checkAvailability();
      }, 500);

      return () => clearTimeout(delayDebounceFn);
    } else {
      setIsUsernameAvailable(null);
    }
  }, [username]);

  const handleUsernameChange = (e: any) => {
    setUsername(e.target.value);
    form.setFieldsValue({ username: e.target.value });
  };

  const validateUsername = (value: any) => {
    const regex = /^RPDXA/;
    if (regex.test(value)) {
      setIsUsernameAvailable(true);  // Mock availability check
    } else {
      setIsUsernameAvailable(false);
    }
  };

  const validateFormat = (_: any, value: any) => {
    const regex = /^RPDXA/;
    if (value && !regex.test(value)) {
      return Promise.reject(new Error('Username must start with "RPDXA"'));
    }
    return Promise.resolve();
  };


  
  const handlePayment = async (value: any) => {
    setIsLoading(true);
  
    const selectedProductIds = [
      value.product1,
      value.product2,
      value.product3,
      value.product4,
      value.product5,
      value.product6,
      value.product7,
    ].filter(id => id !== null); // Keep null values out
  
    // Validate address and pincode
    if (!value.address || !value.pincode) {
      setIsLoading(false);
      return message.error("Please enter address and pincode.");
    }
  
    let totalDiscountedAmount = 0;
  
    const handleIndividualPayment = async (productId: string, transactionId: string) => {
      const product = productData.find((p: any) => p._id === productId);
  
      if (!product) {
        throw new Error("Invalid product selected");
      }
  
      totalDiscountedAmount = form.getFieldValue('amount');
      const selectedProduct = productData.filter((product: any) => selectedProductIds.includes(product._id));
  
      const totalIpQty = selectedProduct.reduce((sum: any, product: any) => sum + product.ipQty, 0);
      const totalAmount = selectedProduct.reduce((sum: any, product: any) => sum + product.price, 0);
      const selectedProductName = selectedProduct.map((product: any) => product.name);
      const orderItems = selectedProductIds.map((id) => {
        const product = productData.find((p: any) => p._id === id);
        if (product) {
          return {
            productId: product._id,
            quantity: 1,
            amount: parseFloat(product.price),
          };
        }
        return null;
      }).filter(Boolean); // Filter out null values
  
      const orderData = {
        amount: (totalDiscountedAmount * 100).toString(),
        currency: "INR",
        receipt: `receipt_${productId}`,
        orderItems,
        deferAmount: 0,
        totalMrp: totalAmount,
        totalDiscount: totalDiscountedAmount,
        email: value.email,
        totalIp: totalIpQty,
        address: value.address,
        pincode: value.pincode,
        paymentMethod: "Razorpay",
        transactionId,
        firstName: value.firstName,
        lastName: value.lastName,
        mobileNo: value.mobileNo,
      };
  
      try {
        const order = await createRazorpayOrder(orderData);
        const { id: order_id, currency, amount } = order;
  
        if (!order || !order.id) {
          throw new Error("Failed to create Razorpay order");
        }
  
        const options = {
          key: process.env.REACT_APP_RAZOR_PAY_KEY_ID,
          amount: amount.toString(),
          currency: currency,
          image: logo,
          name: "Rapidexie",
          description: `Payment for Product ${productId}`,
          order_id: order_id,
          handler: async function (response: any) {
            console.log("Payment response:", response);
            const paymentData = {
              razorpay_order_id: response.razorpay_order_id,
              razorpay_payment_id: response.razorpay_payment_id,
              razorpay_signature: response.razorpay_signature,
            };
  
            try {
              const verifyResult = await verifyPayment(paymentData);
              if (verifyResult === "OK") {
                let transactionId = response.razorpay_payment_id;
                try {
                  await storeTripodSevenpodOrder({ ...orderData, transactionId });
                  setTransactionId(transactionId);
                  setIsModalVisible(true);
                } catch (error) {
                  console.error("Error storing order:", error);
                  message.error("An error occurred while processing your payment. Please try again.");
                }
                message.success("Payment completed!");
              } else {
                message.error("Payment verification failed.");
              }
            } catch (error) {
              message.error("Error verifying payment. Please try again.");
              console.error("Payment verification error:", error);
            }
          },
          prefill: {
            name: `${value.firstName} ${value.lastName}`,
            email: value.email,
            contact: value.mobileNo,
          },
          theme: {
            color: "#F37254",
          },
        };
  
        const rzp = new (window as any).Razorpay(options);
        rzp.open();
      } catch (error) {
        console.error("Error creating order:", error);
        throw error;
      }
    };
  
    try {
      for (let productId of selectedProductIds) {
        await handleIndividualPayment(productId, `txn_${Math.random().toString(36).substring(7)}`);
      }
    } catch (error) {
      message.error("An error occurred while processing your payment.");
      console.error("Payment process error:", error);
    } finally {
      setIsLoading(false);
    }
  };
  
  

  

  useEffect(() => {
    calculateTotalAmount();
  }, [selectedProducts, productData]);

  const calculateTotalAmount = () => {
    const total = Object.values(selectedProducts).reduce((sum, productId) => {
      if (!productId) return sum;
      const product = productData.find((p: any) => p._id === productId);
      return sum + (product ? product.discountedPrice : 0);
    }, 0);

    form.setFieldsValue({ amount: total });
  };

  const handleProductChange = (field: string, value: string | null) => {
    setSelectedProducts(prev => ({
      ...prev,
      [field]: value
    }));

  }
    
    const handleLoginSuccess = () => {
    setIsLoginModalVisible(false);
    handlePayment({});
  };

  return (
    <div className="lg:mt-48 xl:mt-46 md:mt-36 sm:mt-36 xs:mt-12 mt-12 md:pl-40 md:pr-40  pt-12 pb-3">
      <Modal
        footer={null}
        title=""
        closable={false}
        visible={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
      >
        <ThankYou transactionId={transactionId} />
      </Modal>
      <Form

        form={form}
        onFinish={handlePayment}
        className="bg-white"
      >
        <Row className="m-2 items-center">
          <Col
            xs={24}
            sm={24}
            md={9}
            xl={18}
            xxl={18}
            className="flex justify-start font-bold"
          >
            <h2 className="text-2xl">Pay Online For {isTripod ? "Tripod" : "Sevenpod"}</h2>
          </Col>

          <Col
            xs={24}
            sm={24}
            md={9}
            xl={6}
            xxl={6}
            className="flex justify-end"
          >
            <div className="flex space-x-4">
              <label>
                <input type="radio" checked={isTripod}
                  onChange={() => {
                    setIsTripod(true);
                    setIsSevenpod(false);
                  }}
                />
                Tripod
              </label>
              <label>
                <input type="radio" checked={isSevenpod}
                  onChange={() => {
                    setIsSevenpod(true);
                    setIsTripod(false);
                  }}
                />
                Sevenpod
              </label>
            </div>

          </Col>
        </Row>
        <Row justify={"center"} className=" pt-5 border border-warning-2 bg-white rounded-md">

          <Col xs={24} sm={24} md={24} xl={24} xxl={24}>
            <Row className="bg-white" justify={"center"}>
              <Col span={4} className="d-flex justify-content-start me-5 bg-white mb-5">
                <label className="font-bold">
                  First Name <span className="text-danger">*</span>
                </label>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="firstName"
                  rules={[
                    { required: true, message: "Please enter your First Name!" },
                  ]}
                >
                  <Input
                    size="large"
                    className="rounded border border-1"
                    placeholder="Enter First Name"
                  />
                </Form.Item>
              </Col>
            </Row>
          </Col>

          <Col xs={24} sm={24} md={24} xl={24} xxl={24}>
            <Row className="bg-white" justify={"center"}>
              <Col span={4} className="d-flex justify-content-start me-5 bg-white mb-5">
                <label className="font-bold">
                  Last Name <span className="text-danger">*</span>
                </label>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="lastName"
                  rules={[
                    { required: true, message: "Please enter your Last Name!" },
                  ]}
                >
                  <Input
                    size="large"
                    className="rounded border border-1"
                    placeholder="Enter Last Name"
                  />
                </Form.Item>
              </Col>
            </Row>
          </Col>

          <Col xs={24} sm={24} md={24} xl={24} xxl={24}>
            <Row className="bg-white" justify={"center"}>
              <Col span={4} className="d-flex justify-content-start me-5 bg-white mb-5">
                <label className="font-bold">
                  Email id <span className="text-danger">*</span>
                </label>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="email"
                  rules={[{ required: true, message: "Please enter your Email!" }]}>
                  <Input
                    type="email"
                    size="large"
                    className="rounded border border-1"
                    placeholder="Enter Email id"
                  />
                </Form.Item>
              </Col>
            </Row>
          </Col>

          <Col xs={24} sm={24} md={24} xl={24} xxl={24}>
            <Row className="bg-white" justify={"center"}>
              <Col span={4} className="d-flex justify-content-start me-5 bg-white mb-5">
                <label className="font-bold">
                  Mobile Number <span className="text-danger">*</span>
                </label>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="mobileNo"
                  rules={[
                    { required: true, message: "Please enter your Mobile Number!" },

                  ]}
                >
                  <Input
                    type="number"
                    size="large"
                    className="rounded border border-1"
                    placeholder="Enter Mobile Number"
                  />
                </Form.Item>
              </Col>
            </Row>
          </Col>

          <Col xs={24} sm={24} md={24} xl={24} xxl={24}>
            <Row className="bg-white" justify={"center"}>
              <Col span={4} className="d-flex justify-content-start me-5 bg-white mb-5">
                <label className="font-bold">
                  Amount <span className="text-danger">*</span>
                </label>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="amount"
                  rules={[
                    { required: true, message: "Please enter the Amount!" },

                  ]}
                >
                  <Input
                    disabled
                    size="large"
                    className="rounded border border-1"
                    placeholder="Enter Amount"
                    type="number"
                  />
                </Form.Item>
              </Col>
            </Row>
          </Col>

<Col
  xs={24}
  sm={24}
  md={24}
  xl={24}
  xxl={24}

>
<Row className="bg-white" justify="center">
  <Col span={4} className="d-flex justify-content-start me-5 bg-white mb-5">
    <label className="font-bold">
      Products <span className="text-danger">*</span>
    </label>
  </Col>
  <Col span={12}>
    {/* Product 1 */}
    <Form.Item
      name="product1"
      rules={[{ required: true, message: "Product 1 is required!" }]}
    >
      <Select
        size="large"
        placeholder="Select Product 1"
        onChange={(value) => handleProductChange("product1", value)}
      >
        {productData.map((product: any) => (
          <Option key={product._id} value={product._id}>
            {product.name} - ₹{product.discountedPrice}
          </Option>
        ))}
      </Select>
    </Form.Item>

    <Form.Item
      name="product2"
      rules={[{ required: true, message: "Product 2 is required!" }]}
    >
      <Select
        size="large"
        placeholder="Select Product 2"
        onChange={(value) => handleProductChange("product2", value)}
      >
        {productData.map((product: any) => (
          <Option key={product._id} value={product._id}>
            {product.name} - ₹{product.discountedPrice}
          </Option>
        ))}
      </Select>
    </Form.Item>

    <Form.Item
      name="product3"
      rules={[{ required: true, message: "Product 3 is required!" }]}
    >
      <Select
        size="large"
        placeholder="Select Product 3"
        onChange={(value) => handleProductChange("product3", value)}
      >
        {productData.map((product: any) => (
          <Option key={product._id} value={product._id}>
            {product.name} - ₹{product.discountedPrice}
          </Option>
        ))}
      </Select>
    </Form.Item>

    {isSevenpod && (
      <>
        <Form.Item
          name="product4"
          rules={[{ required: true, message: "Product 4 is required!" }]}
        >
          <Select
            size="large"
            placeholder="Select Product 4"
            onChange={(value) => handleProductChange("product4", value)}
          >
            {productData.map((product: any) => (
              <Option key={product._id} value={product._id}>
                {product.name} - ₹{product.discountedPrice}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          name="product5"
          rules={[{ required: true, message: "Product 5 is required!" }]}
        >
          <Select
            size="large"
            placeholder="Select Product 5"
            onChange={(value) => handleProductChange("product5", value)}
          >
            {productData.map((product: any) => (
              <Option key={product._id} value={product._id}>
                {product.name} - ₹{product.discountedPrice}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          name="product6"
          rules={[{ required: true, message: "Product 6 is required!" }]}
        >
          <Select
            size="large"
            placeholder="Select Product 6"
            onChange={(value) => handleProductChange("product6", value)}
          >
            {productData.map((product: any) => (
              <Option key={product._id} value={product._id}>
                {product.name} - ₹{product.discountedPrice}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          name="product7"
          rules={[{ required: true, message: "Product 7 is required!" }]}
        >
          <Select
            size="large"
            placeholder="Select Product 7"
            onChange={(value) => handleProductChange("product7", value)}
          >
            {productData.map((product: any) => (
              <Option key={product._id} value={product._id}>
                {product.name} - ₹{product.discountedPrice}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </>
    )}
  </Col>
</Row>

</Col>

          <Col xs={24} sm={24} md={24} xl={24} xxl={24}>
            <Row className="bg-white" justify={"center"}>
              <Col span={4} className="d-flex justify-content-start me-5 bg-white mb-5">
                <label className="font-bold">
                  Address <span className="text-danger">*</span>
                </label>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="address"
                  rules={[
                    { required: true, message: "Please enter your Address!" },
                  ]}
                >
                  <Input.TextArea
                    rows={3}
                    size="large"
                    className="rounded border border-1"
                    placeholder="Enter Address"
                  />
                </Form.Item>
              </Col>
            </Row>
          </Col>

          <Col xs={24} sm={24} md={24} xl={24} xxl={24}>
            <Row className="bg-white" justify={"center"}>
              <Col span={4} className="d-flex justify-content-start me-5 bg-white mb-5">
                <label className="font-bold">
                  Pincode <span className="text-danger">*</span>
                </label>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="pincode"
                  rules={[
                    { required: true, message: "Please enter your Pincode!" },
                  ]}
                >
                  <Input
                    type="number"
                    size="large"
                    className="rounded border border-1"
                    placeholder="Enter Pincode"
                  />
                </Form.Item>
              </Col>
            </Row>
          </Col>



          <Col xs={24} sm={24} md={24} xl={24} xxl={24}>
            <Row justify={"center"} className="bg-white">
              <Col
                xs={18}
                sm={18}
                md={12}
                xl={8}
                xxl={6}
                className="bg-white mb-3 d-flex justify-content-center"
              >
                <Form.Item>
                  <button
                    type="submit"
                    className={`px-4 py-2 rounded ${isLoading
                      ? 'bg-gray-500 text-white cursor-not-allowed'
                      : isUsernameAvailable === false
                        ? 'bg-orange-300 text-white cursor-not-allowed'
                        : 'bg-orange-500 text-white hover:bg-blue-600'
                      }`}
                    disabled={isLoading || isUsernameAvailable === false}
                  >
                    {isLoading ? 'Processing...' : 'Pay Now'}
                  </button>
                </Form.Item>
              </Col>
            </Row>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default TripodPayonlineUser;
